import React from "react";
import type { TimelineCursorProps } from "./TimelineCursor.types";

const TimelineCursor: React.FC<TimelineCursorProps> = ({ 
  timeProgress, 
  cursorRef 
}) => {
  return (
    <div
      ref={cursorRef}
      className="absolute top-0 bottom-0 z-20 w-0.5 -translate-x-1/2 transform bg-brand shadow-glow"
      style={{ left: `${timeProgress * 100}%` }}
    >
      <div className="absolute top-0 left-1/2 h-4 w-4 -translate-x-1/2 -translate-y-1/2 transform rounded-full border-2 border-page bg-brand shadow-glow" />
    </div>
  );
};

export default TimelineCursor;